import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Label } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {VideoPlayer} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<VideoPlayer title="GitHub media player">
  <VideoPlayer.Source src="https://primer.github.io/brand/assets/example.mp4" />
  <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
</VideoPlayer>
`}</code></pre>
    <h2>{`With poster`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<VideoPlayer
  poster="https://primer.github.io/brand/assets/example-poster.png"
  title="GitHub media player"
>
  <VideoPlayer.Source src="https://primer.github.io/brand/assets/example.mp4" />
  <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
</VideoPlayer>
`}</code></pre>
    <h2>{`Without branding`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<VideoPlayer showBranding={false} title="GitHub media player">
  <VideoPlayer.Source src="https://primer.github.io/brand/assets/example.mp4" />
  <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
</VideoPlayer>
`}</code></pre>
    <h2>{`With visually hidden title`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<VideoPlayer visuallyHiddenTitle title="GitHub media player">
  <VideoPlayer.Source src="https://primer.github.io/brand/assets/example.mp4" />
  <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
</VideoPlayer>
`}</code></pre>
    <h2>{`With some hidden controls`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<VideoPlayer
  title="GitHub media player"
  showPlayPauseButton={false}
  showSeekControl={true}
  showCCButton={false}
  showMuteButton={false}
  showVolumeControl={false}
  showFullScreenButton={false}
>
  <VideoPlayer.Source
    src="https://primer.github.io/brand/assets/example.mp4"
    type="video/mp4"
  />
  <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
</VideoPlayer>
`}</code></pre>
    <h2>{`Hide controls when paused`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<VideoPlayer title="GitHub media player" showControlsWhenPaused={false}>
  <VideoPlayer.Source
    src="https://primer.github.io/brand/assets/example.mp4"
    type="video/mp4"
  />
  <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
</VideoPlayer>
`}</code></pre>
    <h2>{`Minimal`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<VideoPlayer
  title="GitHub media player"
  visuallyHiddenTitle
  showBranding={false}
  showControlsWhenPaused={false}
>
  <VideoPlayer.Source
    src="https://primer.github.io/brand/assets/example.mp4"
    type="video/mp4"
  />
  <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
</VideoPlayer>
`}</code></pre>
    <h2>{`Custom play icon`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<VideoPlayer
  title="GitHub media player"
  playIcon={() => <PlayIcon size={96} />}
>
  <VideoPlayer.Source
    src="https://primer.github.io/brand/assets/example.mp4"
    type="video/mp4"
  />
  <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
</VideoPlayer>
`}</code></pre>
    <h2>{`Controlling programmatically`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`VideoPlayer`}</inlineCode>{` component exposes a `}<inlineCode parentName="p">{`useVideo`}</inlineCode>{` hook that can be used to control the video programmatically. To use the hook, the `}<inlineCode parentName="p">{`VideoPlayer`}</inlineCode>{` component must be wrapped in a `}<inlineCode parentName="p">{`VideoPlayer.Provider`}</inlineCode>{` component.`}</p>
    <p>{`Full documentation for the `}<inlineCode parentName="p">{`useVideo`}</inlineCode>{` hook can be found `}<a parentName="p" {...{
        "href": "#usevideo-context"
      }}>{`below`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx",
        "metastring": "live",
        "live": true
      }}>{`() => {
  const MyVideoPlayer = () => {
    const {isPlaying, togglePlaying, seek} = useVideo()

    return (
      <Stack direction="vertical">
        <VideoPlayer
          title="GitHub media player"
          showPlayPauseButton={false}
          showSeekControl={false}
          showCCButton={false}
          showMuteButton={false}
          showVolumeControl={false}
          showFullScreenButton={false}
        >
          <VideoPlayer.Source
            src="https://primer.github.io/brand/assets/example.mp4"
            type="video/mp4"
          />
          <VideoPlayer.Track src="https://primer.github.io/brand/assets/example.vtt" />
        </VideoPlayer>
        <Stack direction="horizontal">
          <Button onClick={() => togglePlaying()}>
            {isPlaying ? 'Pause' : 'Play'}
          </Button>
          <Button onClick={() => seek(0)}>Go to start</Button>
          <Button onClick={() => seek((t) => t + 5)}>Skip 5 seconds</Button>
        </Stack>
      </Stack>
    )
  }

  return (
    <VideoPlayer.Provider>
      <MyVideoPlayer />
    </VideoPlayer.Provider>
  )
}
`}</code></pre>
    <h2>{`useVideo Context`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`useVideo`}</inlineCode>{` context provides a comprehensive API for managing video playback, volume, closed captioning, and fullscreen mode.`}</p>
    <p>{`The context can be accessed by using the `}<inlineCode parentName="p">{`useVideo`}</inlineCode>{` hook in any component that is a child of `}<inlineCode parentName="p">{`VideoPlayer.Provider`}</inlineCode>{`.`}</p>
    <p>{`Below is a detailed description of each property and method available in the `}<inlineCode parentName="p">{`useVideo`}</inlineCode>{` context.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`RefObject<HTMLVideoElement>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`A reference to the video element.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`isPlaying`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates if the video is currently playing.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`volume`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The current volume of the video, ranging from 0 to 1.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`isMuted`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates if the video is currently muted.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`volumeBeforeMute`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The volume of the video before it was muted, allowing for easy unmuting to the previous level.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`duration`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The total duration of the video in seconds.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ccEnabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates if closed captions are enabled.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`isFullScreen`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Indicates if the video is currently in fullscreen mode.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`play`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Plays the video.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`pause`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pauses the video.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`togglePlaying`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Toggles between playing and pausing the video.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`setVolume`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`(volumeValOrFn: SetStateAction<number>) => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the volume of the video.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`mute`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Mutes the video.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`unmute`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Unmutes the video.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`toggleMute`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Toggles between muting and unmuting the video.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`setDuration`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`(duration: number) => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the duration of the video.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`seekToPercent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`(percent: number) => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Seeks the video to a specific percentage of its duration.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`seek`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`(secondsValOrFn: SetStateAction<number>) => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Seeks the video to an absolute time, or to a relative time if passed a function.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`enableCC`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Enables closed captions.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`disableCC`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Disables closed captions.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`toggleCC`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Toggles closed captions on and off.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`enterFullScreen`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Enters fullscreen mode.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`exitFullScreen`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Exits fullscreen mode.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`toggleFullScreen`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`() => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Toggles between entering and exiting fullscreen mode.`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Component props`}</h2>
    <h3>{`VideoPlayer `}<Label mdxType="Label">{`Required`}</Label></h3>
    <p><inlineCode parentName="p">{`VideoPlayer`}</inlineCode>{` provides a React alternative to the native HTML `}<inlineCode parentName="p">{`<video />`}</inlineCode>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode>{`, `}<inlineCode parentName="td">{`React.ReactNode[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Takes `}<inlineCode parentName="td">{`<VideoPlayer.Source>`}</inlineCode>{` and `}<inlineCode parentName="td">{`<VideoPlayer.Track>`}</inlineCode>{` elements`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`title`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the title of the video`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`visuallyHiddenTitle`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Visually hides the title of the video in the upper-left corner`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`showBranding`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Displays GitHub branding next to video title`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`poster`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets an image as the starting frame for the video element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class on the `}<inlineCode parentName="td">{`<video>`}</inlineCode>{` element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`showControlsWhenPaused`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Show the video controls when paused`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`showPlayPauseButton`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Show the play button control`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`showSeekControl`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Show the seek control`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`showCCButton`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Show the closed caption toggle control`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`showMuteButton`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Show the mute button control`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`showVolumeControl`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Show the volume control`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`showFullScreenButton`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`true`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Show the full screen button control`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The component API supports all standard HTML attribute props, while providing some additional behavior as described above.`}</p>
    <h3>{`VideoPlayer.Source `}<Label mdxType="Label">{`Required`}</Label></h3>
    <p><inlineCode parentName="p">{`VideoPlayer.Source`}</inlineCode>{` provides a React alternative to the native HTML `}<inlineCode parentName="p">{`<source />`}</inlineCode>{`. The component API supports all standard HTML attribute props.`}</p>
    <h3>{`VideoPlayer.Track `}<Label mdxType="Label">{`Required`}</Label></h3>
    <p><inlineCode parentName="p">{`VideoPlayer.Track`}</inlineCode>{` provides a React alternative to the native HTML `}<inlineCode parentName="p">{`<track />`}</inlineCode>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`kind`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`'subtitles'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'captions'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'descriptions'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'chapters'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'metadata'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'captions'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets how the text track is meant to be used`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`The component API supports all standard HTML attribute props, while providing some additional behavior as described above.`}</p>
    <h3>{`VideoPlayer.Provider`}</h3>
    <p><inlineCode parentName="p">{`VideoPlayer.Provider`}</inlineCode>{` can be used in conjunction with the `}<inlineCode parentName="p">{`useVideo`}</inlineCode>{` hook to enable programmatic access to features such as video playback, volume, closed captioning, and fullscreen mode.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      